module.exports = __webpack_public_path__ + "media/images/landing/en/planning@2x-1b4df4a4ce6ca50691a854e7cc8628d1.png";